import React from 'react';

import './Loading.scss';

const FakeContent = () => (
  <div className='fake-timelineItem'>
    <div className='animatedBackground'>
      <div className='backgroundMasker headerRight'></div>
      <div className='backgroundMasker contentTop'></div>
      <div className='backgroundMasker contentFirstEnd'></div>
      {(() => {
        const components = [];
        let topOffset = 74;
        const leftOffset = [320, 420, 370];
        [0,1,2].map(index => {
          const offSet = topOffset;
          topOffset += 26;
          components.push(
            <div key={`${index}-line`} className='backgroundMasker contentLine' style={{ top: offSet }} />
          )
          components.push(
            <div key={`${index}-end`} className='backgroundMasker contentEnd'
              style={{ top: offSet + 12, left: `${leftOffset[index%4]}px` }}
            />
          )
        })
        return components;
      })()}
    </div>
  </div>
);

export default FakeContent;
